import React from "react";
import Modal from "react-modal";
import { useAuth } from "../../hooks/auth";
import "./styles.css";
import pausedImage from "../../assets/images/paused-image.png";
import { putRequest } from "utils/request";
import { getRequest } from "utils/request";
import { useNotification } from "hooks/notification";
import Swal from "sweetalert2";
// import { postRequest } from 'utils/request';
import api from "services/axios";

const customStyles = {
  content: {
    top: "50%",
    border: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(0, 0, 0, 0)",
    width: "100%",
    height: "100%",
  },
  overlay: {
    overflow: "auto",
    transition: "(top 0.4s, opacity 0.4s)",
    zIndex: 100000,
    background: "rgba(0, 0, 0, 0.4)",
  },
};

const PausedModal = () => {
  const { isPaused, setIsPaused, user } = useAuth();
  const { selectedCompany } = useNotification();

  const stopPauseInDb = () => {
    putRequest(`/users/pauseAttendant`, { isPaused: false }).then((e) => {
      if (e.success) {
        setIsPaused(false);
        sessionStorage.removeItem("@Omni:isPaused");
        const user = JSON.parse(sessionStorage.getItem("@Omni:user"));
        user.isPaused = false;
        sessionStorage.setItem("@Omni:user", JSON.stringify(user));
      }
    });
  };

  const stopPause = () => {
    setIsPaused(false);
    getRequest(
      `/companiessettings?CompanyId=${selectedCompany.id}&code=RETURNPAUSEPASSWORD`
    ).then((e) => {
      if (e.success) {
        if (e.data.id) {
          Swal.fire({
            title: "Informe sua senha",
            input: "password",
            showCancelButton: true,
            showLoaderOnConfirm: true,
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            preConfirm: async (login) => {
              await api
                .post("/authentications/admin", {
                  login: user.login,
                  password: login,
                })
                .then((auth) => {
                  if (auth.data.success) {
                    stopPauseInDb();
                  } else {
                    Swal.showValidationMessage(`Senha invalida`);
                  }
                });
            },
          }).then(async (resp) => {
            if (resp.isDismissed) {
              setIsPaused(true);
            }
          });
        } else {
          stopPauseInDb();
        }
      }
    });
  };

  return (
    <Modal
      isOpen={isPaused}
      onRequestClose={() => setIsPaused(false)}
      style={customStyles}
      ariaHideApp={false}
      shouldCloseOnOverlayClick
    >
      <div className="paused-modal-container">
        <div className="paused-modal-center">
          <img width="60%" src={pausedImage} alt="paused" />
          <div>{user.nickName}, seu atendimento esta em pausa</div>
          <button onClick={stopPause} className="paused-modal-return-button">
            Sair da pausa
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PausedModal;
